module.exports = __webpack_public_path__ + "static/img/3.5fcb839.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/eng/3.png
// module id = gJ4Z
// module chunks = 0